import {Settings} from "@/constants/settings";

export function SpaceTr(key: string): string {
    return ' ' + Tr(key);
}

export function TrSpace(key: string): string {
    return Tr(key) + ' ';
}

export function SpaceTrSpace(key: string): string {
    return ' ' + Tr(key) + ' ';
}

export function Tr(key: string): string {
    if (!(key in Settings.LANG)) {
        console.log('ERROR: key ' + key + ' not found!!!');
        console.error('ERROR: key ' + key + ' not found!!!');
        return '???';
    }
    return Settings.LANG[key as keyof typeof Settings.LANG];
}
